module.exports = __webpack_public_path__ + "static/media/1274_CareTeam_bio8.b398dfcb.png";